<script>
    import QuickInput from '../QuickInput.svelte'
    import Icon from 'views/components/icon/Icon.svelte'

    /**
     * @typedef {Object} Props
     * @property {string} [value] - Optional initial value of the input.
     * @property {string} [label] - Optional string to use as <label>.
     */

    /** @type {Props} */
    const { value = '', label = '' } = $props();

    let inputElement = $state()

    function copyValue() {
        try {
            inputElement.select()
            const copySuccess = document.execCommand('copy')
            if (copySuccess) {
                Backbone.View.layout.openStatus(
                    window.i18n.gettext('The text has been copied to your clipboard.'),
                    'success'
                )
            } else {
                throw new Error('Could not copy to clipboard…')
            }
        } catch (e) {
            // Capture exception in sentry
            window.sentry.withScope(() => {
                window.sentry.captureException(e)
            })

            Backbone.View.layout.openStatus(
                window.i18n.gettext('We could not copy this text to your clipboard...')
            )
        }
    }
</script>

<QuickInput
    {value}
    isReadOnly="true"
    bind:inputElement
>
    {#snippet specialActions()}
        <button onclick={copyValue}><Icon name="copy"></Icon>{label}</button>
    {/snippet}
</QuickInput>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
button {
  font-size: 14px;
  border-radius: 12px;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  transition: background 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
button :global(svg) {
  width: 16px;
  height: 16px;
  transition: fill 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
  flex-shrink: 0;
}
button {
  color: #fff;
  background-color: #122d40;
  border: solid 1px #122d40;
}
button > :global(*) {
  display: inline-flex;
}
button > :global(*:empty) {
  display: none;
}
@media (hover: hover) {
  button:hover {
    background-color: hsl(205, 60%, 44%);
    border-color: hsl(205, 60%, 44%);
    color: #fff;
  }
  button:hover :global(svg) {
    fill: #fff;
  }
}
button:active {
  background-color: hsl(205, 58%, 38%);
  border-color: hsl(205, 58%, 38%);
  color: #fff;
}
button:active :global(svg) {
  fill: #fff;
}
button {
  flex-shrink: 0;
  border-radius: 0;
  gap: 8px;
}
button:last-child {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}</style>
